module.exports = __webpack_public_path__ + "static/media/FC2_Star_Rating_2024_ALl plans_001_002_003_English.85aad230.pdf";